module.exports = __webpack_public_path__ + "static/media/ppms_sampleChamber2.dc994d85.png";